/**
 * @function : ERxList
 * @description : To show the list of ERx uploaded by doctor in ongoing consultation screen and on
 *                editing the prescription screen.
 */
import React, { useState, useEffect } from "react";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import axios from "axios";
import moment from "moment";
import DocumentContainer from "../UI Component/DocumentViewer/DocumentCotainer";
import ShareManualRxModal from "./ShareManualRxMoadal";
import ErxCellPrescription from "./ErxCellPrescription";
import { APPROVE_AND_SHARE_ERX } from "../ERXViewContainer/ERXViewApiHandler/apiConstants";
import Loader from "../UI Component/Loader/Loader";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { USER_TYPE } from "../../Util/constants";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
import { c2cPostApiHandler } from "../../Util/c2cApiHandler";
import ShareWithPharmacyBtn from "../ERXViewContainer/common/ShareWithPharmacyBtn";

const ERxListPrescription = (props) => {
  const { pharmacyList, getPastConsultationsApi, handleSharePharmacyBtn } =
    props;

  const [e_rx_list, setERxList] = useState([]);
  const [saved_e_rx_list, setSavedErxList] = useState([]);
  const [initalSavedTime, setInitialSavedtime] = useState("");
  const [showRxModal, setshowRxModal] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const [documentShow, setDocumentShow] = useState(false);
  const [fullView, setFullView] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [documentDetails, setDocumentDetails] = useState("");
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);

  useEffect(() => {
    if (props?.sharedPrescriptions && props?.sharedPrescriptions.length > 0) {
      setERxList(props?.sharedPrescriptions);
    } else {
      setERxList([]);
    }
  }, [props?.sharedPrescriptions]);

  useEffect(() => {
    if (props?.savedPrescriptions && props?.savedPrescriptions.length > 0) {
      setSavedErxList(props?.savedPrescriptions);
      let consultEndTime =
        props?.appointmentData?.appointment_journey_time?.consultation_ended
          ?.consultation_ended_time;
      let checkDate = consultEndTime
        ? consultEndTime
        : props?.savedPrescriptions[0]?.created_at;
      let expiryDate = moment(checkDate)?.add(2, "days")?.format("MMM DD,YYYY");
      let expiryMoment = moment(new Date(checkDate))?.format("hh:mm a");
      let expiresAt = `Expiring on ${expiryDate} at ${expiryMoment}`;
      setInitialSavedtime(expiresAt);
    } else {
      setSavedErxList([]);
    }
  }, [props?.savedPrescriptions]);

  const downloadURI = async (url, name, fileType) => {
    const blob = await axios.get(url, {
      headers: {
        "Content-Type": "application/octet-stream",
      },
      responseType: "blob",
    });
    const a = document.createElement("a");
    const href = window.URL.createObjectURL(blob.data);
    a.href = href;
    a.download = name + "." + fileType.trim();
    a.click();
  };

  const ShareERx = (data) => {
    afterLoginApiAxios
      .post(
        "doctor/share-e-prescription",
        {
          user_id: userType === USER_TYPE.STAFF ? staffId : userId,
          appointment_id: data.appointment_id,
          prescription_id: data.prescription_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        props.fetchSharedPrescriptions();
        if (response.data.statusCode === 200) {
          setshowRxModal(true);
        }
      })
      .catch((err) => C2CConsole.log(err));
  };

  function closeNotification() {
    setDocumentShow(false);
    setFileUrl("");
    setFileName("");
    setFileType("");
    setFullView(false);
  }

  const getErxDetails = (details) => {
    setDocumentDetails(details);
  };
  const ShareSavedErx = async (result) => {
    let reqPayload = {
      "authorizer-principal-id": {
        user_type: userType === USER_TYPE.STAFF ? "4" : "1",
        user_id: userType === USER_TYPE.STAFF ? staffId : userId,
      },
      appointment_id: result.appointment_id,
      prescription_id: result.saved_prescription_id,
    };
    setShowLoader(true);

    // hit approve and share ==>
    const shareRXResponse = c2cPostApiHandler(
      APPROVE_AND_SHARE_ERX,
      reqPayload
    ); //Fetch API Data
    await shareRXResponse.then(([res, error]) => {
      setShowLoader(false);

      if (!error && res?.data?.statusCode === 200) {
        props.fetchSharedPrescriptions();
        getPastConsultationsApi();
        let set = props?.setERXCounter();
        setshowRxModal(true);
      }
    });
    // <==
  };

  const displayShareWithPharmacyBtnUI = () => {
    return (
      <>
        {pharmacyList.length > 0 && (
          <ShareWithPharmacyBtn
            handleSharePharmacyBtn={() =>
              handleSharePharmacyBtn(props.prescription_id, "erx")
            }
          />
        )}
      </>
    );
  };

  return (
    <>
      {showLoader && <Loader />}
      {
        <div>
          {saved_e_rx_list?.length > 0 && userType != USER_TYPE.STAFF ? (
            <>
              <div className="rx_subheading my-3 erx-saved-and-shared-title">
                Saved E-Prescriptions ({saved_e_rx_list.length})
              </div>
              {saved_e_rx_list?.length > 0 ? (
                <ErxCellPrescription
                  key={"saved"}
                  e_rx_list={saved_e_rx_list}
                  setFileName={setFileName}
                  setFileType={setFileType}
                  setFileUrl={setFileUrl}
                  setDocumentShow={setDocumentShow}
                  downloadURI={downloadURI}
                  ShareSavedErx={ShareSavedErx}
                  prescription_id={props.prescription_id}
                  icons={{
                    edit: userType === USER_TYPE.STAFF ? false : true,
                    view: true,
                    download: true,
                    share: true,
                  }}
                  editCallBack={props.onEditCallBack}
                  saved={true}
                  displaySubContent={displayShareWithPharmacyBtnUI()}
                  getErxDetails={getErxDetails}
                />
              ) : null}
            </>
          ) : null}
          {e_rx_list.length > 0 ? (
            <>
              <div className="rx_subheading my-3 erx-saved-and-shared-title">
                Shared E-Prescriptions ({e_rx_list.length})
              </div>
              {e_rx_list.length > 0 ? (
                <ErxCellPrescription
                  key={"shared"}
                  e_rx_list={e_rx_list}
                  setFileName={setFileName}
                  setFileType={setFileType}
                  setFileUrl={setFileUrl}
                  setDocumentShow={setDocumentShow}
                  downloadURI={downloadURI}
                  ShareERx={ShareERx}
                  icons={{
                    edit: false,
                    view: true,
                    download: true,
                    share: true,
                  }}
                  getErxDetails={getErxDetails}
                />
              ) : null}
            </>
          ) : userType === USER_TYPE.STAFF ? (
            <div className="rx_subheading my-3">
              Shared E-Prescriptions (
              {e_rx_list?.length ? e_rx_list?.length : 0})
            </div>
          ) : null}
        </div>
      }
      {documentShow && (
        <DocumentContainer
          cancelHandler={closeNotification}
          fullViewHandler={() => {
            setFullView(!fullView);
          }}
          url={fileUrl}
          fileName={fileName}
          fileType={fileType}
        />
      )}
      <ShareManualRxModal
        show={showRxModal}
        handleClose={() => {
          setshowRxModal(false);
        }}
      />
    </>
  );
};

export default ERxListPrescription;
